import { Command } from 'commands/Commands';

export class ChangeAddressOrder extends Command {
  type: string = 'ChangeAddressOrder';
  priority: number = 100;
}